module.exports = new __parcel__URL__("troops_text.84d5774a.png").toString();